export default __webpack_public_path__ + "static/media/2.8bb7c7d8.webp";